import React, { useContext, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { apiRoutes } from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import Util from '../../../Util';
import ReactStars from "react-rating-stars-component";
import alertify from 'alertifyjs';
import DoctorAvatar from './DoctorAvatar';

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
  };

const DoctorList = (props) => {
    const { userState } = useContext(AuthContext);
    const [data, setData] = useState([]);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + userState.token
        }
    };

    useEffect(() => {
        loadGrid();
    }, []);

    const loadGrid = () => {
        axios.get(apiRoutes.GetAllDoctors, options)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setData(data);
                }
        }, (error) => {
            console.log(error);
        });
    }

    const getColumns = () => {
        let columns = [];
        if(props.columnsToShow == undefined || props.columnsToShow.includes("Doctor Name"))
        {
            columns.push({
                name: 'Doctor Name',
                selector: 'name',
                sortable: true,
                width: '250px',
                cell: row => <DoctorAvatar doctor={row} /> 
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Speciality"))
        {
            columns.push({
                name: 'Speciality',
                selector: 'speciality',
                sortable: true,
                width: '120px'
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Member Since"))
        {
            columns.push({
                name: 'Member Since',
                selector: 'CreatedDate',
                sortable: true,
                width: '250px',
                cell: row => <div> {
                                    new Intl.DateTimeFormat("en-GB", {
                                    year: "numeric",
                                    month: "short",
                                    day: "2-digit"
                                    }).format(new Date(row.CreatedDate+".000Z"))
                                }<br /><small>{Util.getTimeAMPM((new Date(row.createdDate)))}</small></div> 
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Earned"))
        {
            columns.push({
                name: 'Earned',
                selector: 'amountErned',
                sortable: true,
                width: '120px',
                right: true,
                cell: row => <div>${row.amountErned}</div> 
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Acount Status"))
        {
            columns.push({
                name: 'Acount Status',
                selector: 'isActive',
                sortable: true,
                width: '190px',
                cell: row => <div className="status-toggle">
                                <input type="checkbox" id={"status_" + row.doctorId} className="check" checked={row.isActive} onChange={e => handleChange(row.doctorId, row.isActive)} />
                                <label htmlFor={"status_" + row.doctorId} className="checktoggle">checkbox</label>
                            </div>
            });
        }

        if(props.columnsToShow == undefined || props.columnsToShow.includes("Reviews"))
        {
            columns.push({
                name: 'Reviews',
                selector: 'rating',
                sortable: true,
                width: '120px',
                right: true,
                cell: row => <div><ReactStars value={row.rating} edit={false} size={20} /></div> 
            });
        }

        return columns;
    }

    const handleChange = (id, isActive) => {

        alertify.confirm("Warning!", `Are you sure want to ${ isActive ? 'disable' : ' enable' }?`,
        function(){
            axios.post(apiRoutes.ToggleDoctor, JSON.stringify({id: id}), options)
            .then((response) => {
                alertify.success(`Doctor ${ isActive ? 'disabled' : ' enabled' } successfully`);
                loadGrid();
            }, (error) => {
                console.log(error);
            });
        },
        function(){
          
        });
    };

    let columns = getColumns();

    return (  
        <div>
            <DataTable
                title={props.title} 
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                highlightOnHover={true}
            />
        </div>
    );
}
 
export default DoctorList;